// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../bundler/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../bundler/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.anna-shell {
    --anna-ink: #243c38;
    --anna-muted: #73827e;
    --anna-accent: #276b5e;
    background: #f7f8f5;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    flex: 1;
    min-height: 0;
    overflow: hidden;
}
.anna-shell *:not(.anna-workspace-content, .anna-workspace-content *) {
    box-sizing: border-box;
}
.anna-shell button:not(.anna-workspace-content *),
.anna-shell textarea:not(.anna-workspace-content *),
.anna-shell a:not(.anna-workspace-content *) {
    font: inherit;
}
.anna-shell button:not(.anna-workspace-content *) {
    cursor: pointer;
}
.anna-shell button:not(.anna-workspace-content *):disabled {
    opacity: 0.45;
    cursor: default;
}
.anna-shell button:not(.anna-workspace-content *):focus-visible,
.anna-shell a:not(.anna-workspace-content *):focus-visible,
.anna-shell textarea:not(.anna-workspace-content *):focus-visible {
    outline: 2px solid var(--anna-accent);
    outline-offset: 3px;
}
.anna-header {
    height: 72px;
    flex: none;
    display: flex;
    align-items: center;
    gap: 28px;
    padding: 0 30px;
    border-bottom: 1px solid #e1e7e2;
    background: #fff;
}
.anna-brand {
    background: none;
    border: 0;
    color: var(--anna-ink);
    font-size: 30px !important;
    font-weight: 600 !important;
    letter-spacing: -1.3px;
    display: flex;
    align-items: baseline;
    gap: 8px;
}
.anna-brand span {
    font-size: 13px;
    letter-spacing: 0;
    font-weight: 400;
    color: var(--anna-muted);
}
.anna-header-note {
    color: var(--anna-muted);
    font-size: 13px;
}
.anna-search {
    margin-left: auto;
    border: 0;
    background: none;
    color: var(--anna-ink);
    font-size: 13px !important;
}
.anna-workspace-link {
    color: var(--anna-ink);
    text-decoration: none;
    font-size: 13px !important;
}
.anna-layout {
    display: grid;
    grid-template-columns: minmax(330px, 38%) minmax(0, 1fr);
    flex: 1;
    min-height: 0;
}
.anna-conversation {
    display: flex;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
    border-right: 1px solid #e1e7e2;
    background: #fff;
    position: relative;
}
.anna-conversation-heading {
    display: flex;
    gap: 12px;
    align-items: center;
    padding: 24px 26px 20px;
    flex: none;
}
.anna-small-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #e3eee8;
    overflow: hidden;
    display: grid;
    place-items: center;
}
.anna-small-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.anna-conversation-heading strong {
    font-size: 15px;
    font-weight: 500;
}
.anna-conversation-heading > div > span {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 5px;
    font-size: 12px;
    color: var(--anna-muted);
}
.anna-shell i:not(.anna-workspace-content *) {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #5b9b83;
}
.anna-context {
    display: flex;
    align-items: center;
    margin: 0 24px 8px;
    padding: 8px 12px;
    background: #edf4ef;
    border-radius: 8px;
    font-size: 12px;
    gap: 8px;
}
.anna-context span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.anna-context button {
    margin-left: auto;
    border: 0;
    background: none;
}
.anna-messages {
    overflow: auto;
    flex: 1;
    min-height: 0;
    padding: 16px 24px 24px;
    overscroll-behavior: contain;
    overflow-wrap: anywhere;
}
.anna-welcome {
    padding: 48px 4px 28px;
}
.anna-eyebrow {
    font-size: 11px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: var(--anna-muted);
}
.anna-welcome h1 {
    font-size: 34px;
    font-weight: 400;
    letter-spacing: -1.1px;
    line-height: 1.2;
    margin: 16px 0;
}
.anna-welcome p {
    color: var(--anna-muted);
    font-size: 15px;
    line-height: 1.65;
    margin: 0 0 30px;
}
.anna-suggestions {
    display: flex;
    flex-direction: column;
    gap: 9px;
    align-items: flex-start;
}
.anna-suggestions button {
    border: 1px solid #e1e7e2;
    background: #fafbf9;
    border-radius: 9px;
    color: var(--anna-ink);
    padding: 11px 14px;
    font-size: 13px;
    text-align: left;
}
.anna-message {
    border-radius: 12px;
    margin: 0 0 24px;
    padding: 10px 0;
}
.anna-message-user {
    margin-left: 32px;
    background: #f0f4ef;
    padding: 14px 16px;
}
.anna-message-author {
    display: flex;
    gap: 12px;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 8px;
    color: var(--anna-muted);
}
.anna-message-author time {
    margin-left: auto;
    font-size: 10px;
    font-weight: 400;
}
.anna-composer {
    flex: none;
    margin: 0 22px;
    padding-top: 8px;
}
.anna-composer-field {
    display: flex;
    gap: 8px;
    align-items: flex-end;
    padding: 10px 10px 10px 14px;
    border: 1px solid #d9e2db;
    background: #fafbf9;
    border-radius: 15px;
}
.anna-composer textarea {
    min-width: 0;
    resize: none;
    width: 100%;
    background: transparent;
    border: 0;
    color: var(--anna-ink);
    font-size: 14px;
    line-height: 1.5;
    padding: 4px 0;
}
.anna-composer textarea::placeholder {
    color: #84918b;
}
.anna-send {
    width: 36px;
    height: 36px;
    flex: none;
    border: 0;
    border-radius: 50%;
    background: var(--anna-accent);
    color: white;
    font-size: 23px !important;
}
.anna-composer-footer {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    font-size: 10px;
    color: var(--anna-muted);
    padding: 9px 2px;
}
.anna-voice-controls {
    padding: 4px 22px 16px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    flex: none;
}
.anna-end-call {
    color: #a12f36;
    background: #fbefef;
    border: 1px solid #f2d2d5;
    border-radius: 20px;
    padding: 8px 12px;
}
.anna-duration {
    font-size: 12px;
    color: var(--anna-muted);
}
.anna-stage {
    position: relative;
    min-width: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.anna-presence {
    flex: 1;
    min-height: 0;
    overflow: auto;
    padding: 32px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    background: radial-gradient(ellipse at 50% 40%, #e5eee3 0, #f3f4ed 48%, #f8f8f3 100%);
}
.anna-presence-kicker {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: var(--anna-muted);
    margin-bottom: 32px;
}
.anna-portrait {
    width: clamp(160px, 23vw, 330px);
    aspect-ratio: 1;
    border-radius: 50%;
    padding: 9px;
    border: 1px solid #d7e0d1;
    box-shadow: 0 15px 70px #465e4314;
    flex: none;
}
.anna-portrait img,
.anna-portrait > span {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
    background: #dbe7da;
    display: grid;
    place-items: center;
    font-size: 70px;
    color: #608272;
}
.anna-presence-live .anna-portrait {
    border-color: #639984;
    box-shadow:
        0 0 0 10px #6b9b7715,
        0 15px 70px #465e4314;
}
.anna-presence-copy {
    text-align: center;
    margin: 30px 0 26px;
}
.anna-presence-copy h2 {
    font-size: 34px;
    font-weight: 400;
    letter-spacing: -1px;
    margin: 10px 0;
}
.anna-presence-copy p {
    font-size: 14px;
    color: var(--anna-muted);
    line-height: 1.5;
}
.anna-quick-views {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: center;
}
.anna-quick-views button {
    min-width: 110px;
    display: flex;
    gap: 24px;
    justify-content: space-between;
    background: #ffffff90;
    border: 1px solid #dce4d8;
    border-radius: 10px;
    padding: 13px 16px;
    color: var(--anna-ink);
    font-size: 13px;
}
.anna-workspace {
    flex: 1;
    min-height: 0;
    min-width: 0;
    flex-direction: column;
    background: white;
}
.anna-workspace-toolbar {
    flex: none;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    padding: 12px 14px;
    border-bottom: 1px solid #e1e7e2;
    background: #fafbf9;
}
.anna-workspace-toolbar button {
    border: 0;
    background: transparent;
    color: var(--anna-ink);
    font-size: 12px;
    padding: 8px;
    border-radius: 6px;
}
.anna-workspace-toolbar button:hover,
.anna-workspace-toolbar button[aria-pressed='true'] {
    background: #e6eee4;
}
.anna-workspace-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
    overflow: hidden;
    isolation: isolate;
}
.anna-pending {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: none;
    padding: 12px 16px;
    background: #edf4ef;
    font-size: 13px;
}
.anna-pending span {
    flex: 1;
}
.anna-pending button,
.anna-error button {
    border: 1px solid #c9dbce;
    background: white;
    border-radius: 6px;
    padding: 6px 10px;
    color: var(--anna-accent);
}
.anna-error {
    color: #a3373c;
    padding: 10px;
    font-size: 13px;
    line-height: 1.5;
}
.anna-empty {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 14px;
    padding: 28px;
}
.anna-muted {
    color: var(--anna-muted);
    font-size: 13px;
}
.anna-text-button {
    border: 0;
    background: none;
    color: var(--anna-accent);
    padding: 8px;
}
.anna-latest {
    align-self: center;
    border: 1px solid #dce4d8;
    border-radius: 20px;
    padding: 7px 14px;
    color: var(--anna-accent);
    background: white;
}
.anna-mobile-dock {
    display: none;
}
@media (max-width: 760px) {
    .anna-header {
        height: 54px;
        padding: 0 16px;
    }
    .anna-header-note {
        display: none;
    }
    .anna-brand {
        font-size: 26px !important;
    }
    .anna-layout {
        display: flex;
        flex-direction: column-reverse;
        position: relative;
    }
    .anna-stage {
        flex: 0 0 30%;
    }
    .anna-conversation {
        flex: 1;
        border-right: 0;
        border-top: 1px solid #e1e7e2;
    }
    .anna-conversation-heading {
        display: none;
    }
    .anna-presence {
        flex-direction: row;
        gap: 20px;
        padding: 14px 20px;
        justify-content: center;
    }
    .anna-presence-kicker,
    .anna-quick-views {
        display: none;
    }
    .anna-portrait {
        width: 110px;
        padding: 4px;
    }
    .anna-presence-copy {
        margin: 0;
        text-align: left;
    }
    .anna-presence-copy h2 {
        font-size: 23px;
    }
    .anna-presence-copy p {
        font-size: 12px;
        max-width: 180px;
        margin-bottom: 0;
    }
    .anna-presence-copy .anna-eyebrow {
        font-size: 9px;
    }
    .anna-messages {
        padding: 14px 16px;
    }
    .anna-welcome {
        padding: 18px 4px;
    }
    .anna-welcome h1 {
        font-size: 28px;
    }
    .anna-welcome p {
        font-size: 13px;
        margin-bottom: 16px;
    }
    .anna-suggestions {
        flex-direction: row;
        flex-wrap: wrap;
    }
    .anna-suggestions button {
        font-size: 12px;
        padding: 9px 10px;
    }
    .anna-composer {
        margin: 0 14px;
    }
    .anna-composer-footer span:last-child {
        display: none;
    }
    .anna-voice-controls {
        padding: 0 14px max(8px, env(safe-area-inset-bottom));
    }
    .anna-has-workspace .anna-stage {
        flex: 1;
    }
    .anna-has-workspace .anna-conversation {
        flex: 0 0 auto;
    }
    .anna-has-workspace .anna-conversation .anna-messages,
    .anna-has-workspace .anna-context {
        display: none;
    }
    .anna-has-workspace .anna-mobile-dock {
        display: flex;
        gap: 10px;
        align-items: center;
        padding: 10px 16px;
        width: 100%;
        background: white;
        border: 0;
        font-size: 13px;
        color: var(--anna-ink);
    }
    .anna-mobile-dock img {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        object-fit: cover;
    }
    .anna-mobile-dock span:last-child {
        margin-left: auto;
    }
    .anna-chat-expanded.anna-has-workspace .anna-conversation {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 78%;
        z-index: 30;
        border-radius: 18px 18px 0 0;
        box-shadow: 0 -12px 45px #18302630;
        overflow: hidden;
    }
    .anna-chat-expanded.anna-has-workspace .anna-conversation .anna-messages {
        display: block;
    }
    .anna-workspace-toolbar {
        padding: 4px 8px;
        gap: 0;
    }
    .anna-workspace-toolbar button {
        font-size: 11px;
        padding: 9px 6px;
    }
    .app-keyboard-open .anna-shell .anna-stage {
        flex-basis: 0;
    }
    .app-keyboard-open .anna-shell.anna-has-workspace .anna-conversation {
        height: 100%;
    }
}

/* Temporary overlays: the actual task/note DOM and text selection remain untouched. */
.anna-highlight-overlay {
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 10000;
}
.anna-highlight-overlay span {
    position: absolute;
    pointer-events: none;
    border-radius: 3px;
    box-sizing: border-box;
}
.anna-highlight-marker {
    background: rgba(255, 211, 64, 0.38);
    border-bottom: 2px solid #c79100;
}
.anna-highlight-outline {
    outline: 2px solid #27806a;
    outline-offset: 2px;
    background: rgba(65, 166, 131, 0.08);
}
.anna-workspace-content {
    position: relative;
}
.anna-highlight-caption {
    position: absolute;
    top: 8px;
    right: 12px;
    max-width: min(340px, calc(100% - 24px));
    z-index: 31;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 12px;
    border: 1px solid #d9bf6d;
    border-radius: 9px;
    color: #493d18;
    background: #fff8db;
    box-shadow: 0 3px 14px #493d1818;
    font-size: 12px;
}
.anna-highlight-caption span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.anna-highlight-caption button {
    border: 0;
    background: transparent;
    color: inherit;
    padding: 4px;
}

.anna-mobile-tabs,
.anna-conversation,
.anna-header,
.anna-workspace-toolbar,
.anna-browser-surface,
.anna-pending {
    font-family: Roboto, Arial, sans-serif;
    color: var(--anna-ink);
}

/* The workspace subtree stays in the same position in both layouts. */
.anna-zoom-shell > [hidden],
.anna-zoom-shell .anna-workspace-toolbar[hidden] {
    display: none !important;
}
.anna-zoom-shell .anna-layout {
    grid-template-columns: minmax(280px, var(--anna-chat-width, 36%)) 6px minmax(0, 1fr);
}
.anna-zoom-shell .anna-stage {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
}
.anna-zoom-shell .anna-workspace {
    display: flex;
    flex: 1;
    min-height: 0;
}
.anna-zoom-shell .anna-workspace-content {
    display: flex;
    flex: 1;
    min-height: 0;
    overflow: hidden;
}
.anna-zoom-shell .anna-workspace-content > * {
    min-width: 0;
}
.anna-zoom-shell .anna-conversation {
    min-width: 0;
}
.anna-zoom-back,
.anna-control {
    margin-left: auto;
}
.anna-zoom-shell .anna-brand {
    font-size: 19px !important;
    letter-spacing: 0;
}
.anna-divider {
    cursor: col-resize;
    touch-action: none;
    background: #e1e7e2;
}
.anna-divider:hover,
.anna-divider:focus-visible {
    background: #89b2a4;
}
.anna-mobile-tabs {
    display: none;
}
.anna-surface-hidden {
    position: absolute !important;
    inset: 0;
    visibility: hidden;
    pointer-events: none;
}
.anna-fullscreen {
    background: transparent;
}
.anna-fullscreen .anna-layout {
    display: flex;
    flex: 1;
}
.anna-fullscreen .anna-conversation,
.anna-fullscreen .anna-divider {
    display: none;
}
.anna-fullscreen .anna-stage {
    flex: 1;
}
.anna-fullscreen .anna-workspace {
    width: 100%;
}
.anna-date-divider {
    text-align: center;
    color: var(--anna-muted);
    margin: 16px 0;
    font-size: 12px;
}
.anna-browser-surface {
    flex: 1;
    min-height: 0;
    overflow: auto;
    background: #f7f8f5;
}
.anna-browser-workspace {
    padding: 16px;
}
.anna-browser-heading {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    justify-content: space-between;
}
.anna-browser-heading > div {
    min-width: 0;
    overflow-wrap: anywhere;
}
.anna-browser-heading button {
    flex: none;
}
.anna-browser-workspace button {
    border: 1px solid #d4ded8;
    background: white;
    border-radius: 7px;
    padding: 8px 12px;
}
.anna-browser-frame {
    margin: 12px 0;
    background: #e1e7e2;
}
.anna-browser-frame img {
    display: block;
    width: 100%;
    height: auto;
}
.anna-browser-controls form {
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
}
.anna-browser-controls input {
    min-width: 0;
    flex: 1;
    padding: 8px;
    border: 1px solid #d4ded8;
    border-radius: 6px;
    font-size: 16px;
}
.anna-browser-controls > div {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}
.anna-small {
    font-size: 12px;
    color: var(--anna-muted);
    margin-top: 8px;
}
@media (max-width: 760px) {
    .anna-zoom-shell .anna-layout {
        display: flex;
        flex-direction: column;
        position: relative;
    }
    .anna-zoom-shell .anna-divider {
        display: none;
    }
    .anna-zoom-shell .anna-mobile-tabs {
        display: flex;
        background: white;
        padding: 6px 12px;
        gap: 8px;
    }
    .anna-mobile-tabs button {
        flex: 1;
        border: 0;
        border-radius: 8px;
        padding: 10px;
        background: #f0f3ef;
    }
    .anna-mobile-tabs button[aria-pressed='true'] {
        color: white;
        background: #276b5e;
    }
    .anna-zoom-shell .anna-stage,
    .anna-zoom-shell .anna-conversation {
        flex: 1;
        min-height: 0;
    }
    .anna-zoom-active.anna-mobile-chat .anna-stage,
    .anna-zoom-active.anna-mobile-workspace .anna-conversation {
        position: absolute;
        inset: 0;
        visibility: hidden;
        pointer-events: none;
    }
    .anna-fullscreen .anna-stage {
        visibility: visible;
        position: relative;
    }
    .anna-zoom-shell .anna-header {
        height: auto;
        min-height: 54px;
        gap: 8px;
    }
    .anna-zoom-shell .anna-brand {
        font-size: 16px !important;
    }
    .anna-zoom-shell .anna-zoom-back {
        font-size: 12px;
    }
    .anna-browser-heading {
        flex-wrap: wrap;
    }
}

.anna-zoom-back {
    border: 1px solid #d4ded8;
    background: white;
    border-radius: 8px;
    padding: 9px 14px;
    color: var(--anna-ink);
}
.anna-zoom-back:hover {
    background: #edf4ef;
}
`, "",{"version":3,"sources":["webpack://./components/Anna/anna.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,OAAO;IACP,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,sBAAsB;AAC1B;AACA;;;IAGI,aAAa;AACjB;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;IACb,eAAe;AACnB;AACA;;;IAGI,qCAAqC;IACrC,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,gCAAgC;IAChC,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,SAAS;IACT,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;IAC3B,sBAAsB;IACtB,aAAa;IACb,qBAAqB;IACrB,QAAQ;AACZ;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;AAC5B;AACA;IACI,wBAAwB;IACxB,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,SAAS;IACT,gBAAgB;IAChB,sBAAsB;IACtB,0BAA0B;AAC9B;AACA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb,wDAAwD;IACxD,OAAO;IACP,aAAa;AACjB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;IACf,wBAAwB;AAC5B;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,QAAQ;AACZ;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,iBAAiB;IACjB,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,4BAA4B;IAC5B,uBAAuB;AAC3B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,wBAAwB;AAC5B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,wBAAwB;IACxB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;AAC3B;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;AAC5B;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,QAAQ;IACR,qBAAqB;IACrB,4BAA4B;IAC5B,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,SAAS;IACT,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;IACZ,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,UAAU;AACd;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,OAAO;IACP,aAAa;IACb,cAAc;IACd,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,qFAAqF;AACzF;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,wBAAwB;IACxB,mBAAmB;AACvB;AACA;IACI,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,iCAAiC;IACjC,UAAU;AACd;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB;;6BAEyB;AAC7B;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;AAClB;AACA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,8BAA8B;IAC9B,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,OAAO;IACP,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;AACA;;IAEI,mBAAmB;AACvB;AACA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,OAAO;AACX;AACA;;IAEI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,aAAa;AACjB;AACA;IACI,wBAAwB;IACxB,eAAe;AACnB;AACA;IACI,SAAS;IACT,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;AACA;IACI;QACI,YAAY;QACZ,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,kBAAkB;IACtB;IACA;QACI,aAAa;IACjB;IACA;QACI,OAAO;QACP,eAAe;QACf,6BAA6B;IACjC;IACA;QACI,aAAa;IACjB;IACA;QACI,mBAAmB;QACnB,SAAS;QACT,kBAAkB;QAClB,uBAAuB;IAC3B;IACA;;QAEI,aAAa;IACjB;IACA;QACI,YAAY;QACZ,YAAY;IAChB;IACA;QACI,SAAS;QACT,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI,cAAc;IAClB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,mBAAmB;QACnB,eAAe;IACnB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,cAAc;IAClB;IACA;QACI,aAAa;IACjB;IACA;QACI,qDAAqD;IACzD;IACA;QACI,OAAO;IACX;IACA;QACI,cAAc;IAClB;IACA;;QAEI,aAAa;IACjB;IACA;QACI,aAAa;QACb,SAAS;QACT,mBAAmB;QACnB,kBAAkB;QAClB,WAAW;QACX,iBAAiB;QACjB,SAAS;QACT,eAAe;QACf,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,WAAW;QACX,WAAW;QACX,4BAA4B;QAC5B,kCAAkC;QAClC,gBAAgB;IACpB;IACA;QACI,cAAc;IAClB;IACA;QACI,gBAAgB;QAChB,MAAM;IACV;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QACI,YAAY;IAChB;AACJ;;AAEA,sFAAsF;AACtF;IACI,eAAe;IACf,QAAQ;IACR,oBAAoB;IACpB,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;AACA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,oCAAoC;AACxC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,wCAAwC;IACxC,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,YAAY;AAChB;;AAEA;;;;;;IAMI,sCAAsC;IACtC,sBAAsB;AAC1B;;AAEA,sEAAsE;AACtE;;IAEI,wBAAwB;AAC5B;AACA;IACI,oFAAoF;AACxF;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,aAAa;IACb,OAAO;IACP,aAAa;AACjB;AACA;IACI,aAAa;IACb,OAAO;IACP,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;;IAEI,iBAAiB;AACrB;AACA;IACI,0BAA0B;IAC1B,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;;IAEI,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,6BAA6B;IAC7B,QAAQ;IACR,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,OAAO;AACX;AACA;;IAEI,aAAa;AACjB;AACA;IACI,OAAO;AACX;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,cAAc;IACd,eAAe;AACnB;AACA;IACI,OAAO;IACP,aAAa;IACb,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ,uBAAuB;AAC3B;AACA;IACI,UAAU;AACd;AACA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,QAAQ;IACR,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,OAAO;IACP,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;AACA;IACI,eAAe;IACf,wBAAwB;IACxB,eAAe;AACnB;AACA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,kBAAkB;IACtB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,iBAAiB;QACjB,iBAAiB;QACjB,QAAQ;IACZ;IACA;QACI,OAAO;QACP,SAAS;QACT,kBAAkB;QAClB,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,YAAY;QACZ,mBAAmB;IACvB;IACA;;QAEI,OAAO;QACP,aAAa;IACjB;IACA;;QAEI,kBAAkB;QAClB,QAAQ;QACR,kBAAkB;QAClB,oBAAoB;IACxB;IACA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,QAAQ;IACZ;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,mBAAmB;AACvB","sourcesContent":[".anna-shell {\n    --anna-ink: #243c38;\n    --anna-muted: #73827e;\n    --anna-accent: #276b5e;\n    background: #f7f8f5;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n}\n.anna-shell *:not(.anna-workspace-content, .anna-workspace-content *) {\n    box-sizing: border-box;\n}\n.anna-shell button:not(.anna-workspace-content *),\n.anna-shell textarea:not(.anna-workspace-content *),\n.anna-shell a:not(.anna-workspace-content *) {\n    font: inherit;\n}\n.anna-shell button:not(.anna-workspace-content *) {\n    cursor: pointer;\n}\n.anna-shell button:not(.anna-workspace-content *):disabled {\n    opacity: 0.45;\n    cursor: default;\n}\n.anna-shell button:not(.anna-workspace-content *):focus-visible,\n.anna-shell a:not(.anna-workspace-content *):focus-visible,\n.anna-shell textarea:not(.anna-workspace-content *):focus-visible {\n    outline: 2px solid var(--anna-accent);\n    outline-offset: 3px;\n}\n.anna-header {\n    height: 72px;\n    flex: none;\n    display: flex;\n    align-items: center;\n    gap: 28px;\n    padding: 0 30px;\n    border-bottom: 1px solid #e1e7e2;\n    background: #fff;\n}\n.anna-brand {\n    background: none;\n    border: 0;\n    color: var(--anna-ink);\n    font-size: 30px !important;\n    font-weight: 600 !important;\n    letter-spacing: -1.3px;\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n}\n.anna-brand span {\n    font-size: 13px;\n    letter-spacing: 0;\n    font-weight: 400;\n    color: var(--anna-muted);\n}\n.anna-header-note {\n    color: var(--anna-muted);\n    font-size: 13px;\n}\n.anna-search {\n    margin-left: auto;\n    border: 0;\n    background: none;\n    color: var(--anna-ink);\n    font-size: 13px !important;\n}\n.anna-workspace-link {\n    color: var(--anna-ink);\n    text-decoration: none;\n    font-size: 13px !important;\n}\n.anna-layout {\n    display: grid;\n    grid-template-columns: minmax(330px, 38%) minmax(0, 1fr);\n    flex: 1;\n    min-height: 0;\n}\n.anna-conversation {\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    min-width: 0;\n    border-right: 1px solid #e1e7e2;\n    background: #fff;\n    position: relative;\n}\n.anna-conversation-heading {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    padding: 24px 26px 20px;\n    flex: none;\n}\n.anna-small-avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: #e3eee8;\n    overflow: hidden;\n    display: grid;\n    place-items: center;\n}\n.anna-small-avatar img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n.anna-conversation-heading strong {\n    font-size: 15px;\n    font-weight: 500;\n}\n.anna-conversation-heading > div > span {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin-top: 5px;\n    font-size: 12px;\n    color: var(--anna-muted);\n}\n.anna-shell i:not(.anna-workspace-content *) {\n    display: inline-block;\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #5b9b83;\n}\n.anna-context {\n    display: flex;\n    align-items: center;\n    margin: 0 24px 8px;\n    padding: 8px 12px;\n    background: #edf4ef;\n    border-radius: 8px;\n    font-size: 12px;\n    gap: 8px;\n}\n.anna-context span {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n.anna-context button {\n    margin-left: auto;\n    border: 0;\n    background: none;\n}\n.anna-messages {\n    overflow: auto;\n    flex: 1;\n    min-height: 0;\n    padding: 16px 24px 24px;\n    overscroll-behavior: contain;\n    overflow-wrap: anywhere;\n}\n.anna-welcome {\n    padding: 48px 4px 28px;\n}\n.anna-eyebrow {\n    font-size: 11px;\n    letter-spacing: 1.5px;\n    text-transform: uppercase;\n    color: var(--anna-muted);\n}\n.anna-welcome h1 {\n    font-size: 34px;\n    font-weight: 400;\n    letter-spacing: -1.1px;\n    line-height: 1.2;\n    margin: 16px 0;\n}\n.anna-welcome p {\n    color: var(--anna-muted);\n    font-size: 15px;\n    line-height: 1.65;\n    margin: 0 0 30px;\n}\n.anna-suggestions {\n    display: flex;\n    flex-direction: column;\n    gap: 9px;\n    align-items: flex-start;\n}\n.anna-suggestions button {\n    border: 1px solid #e1e7e2;\n    background: #fafbf9;\n    border-radius: 9px;\n    color: var(--anna-ink);\n    padding: 11px 14px;\n    font-size: 13px;\n    text-align: left;\n}\n.anna-message {\n    border-radius: 12px;\n    margin: 0 0 24px;\n    padding: 10px 0;\n}\n.anna-message-user {\n    margin-left: 32px;\n    background: #f0f4ef;\n    padding: 14px 16px;\n}\n.anna-message-author {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    font-size: 12px;\n    font-weight: 500;\n    margin-bottom: 8px;\n    color: var(--anna-muted);\n}\n.anna-message-author time {\n    margin-left: auto;\n    font-size: 10px;\n    font-weight: 400;\n}\n.anna-composer {\n    flex: none;\n    margin: 0 22px;\n    padding-top: 8px;\n}\n.anna-composer-field {\n    display: flex;\n    gap: 8px;\n    align-items: flex-end;\n    padding: 10px 10px 10px 14px;\n    border: 1px solid #d9e2db;\n    background: #fafbf9;\n    border-radius: 15px;\n}\n.anna-composer textarea {\n    min-width: 0;\n    resize: none;\n    width: 100%;\n    background: transparent;\n    border: 0;\n    color: var(--anna-ink);\n    font-size: 14px;\n    line-height: 1.5;\n    padding: 4px 0;\n}\n.anna-composer textarea::placeholder {\n    color: #84918b;\n}\n.anna-send {\n    width: 36px;\n    height: 36px;\n    flex: none;\n    border: 0;\n    border-radius: 50%;\n    background: var(--anna-accent);\n    color: white;\n    font-size: 23px !important;\n}\n.anna-composer-footer {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    font-size: 10px;\n    color: var(--anna-muted);\n    padding: 9px 2px;\n}\n.anna-voice-controls {\n    padding: 4px 22px 16px;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 8px;\n    flex: none;\n}\n.anna-end-call {\n    color: #a12f36;\n    background: #fbefef;\n    border: 1px solid #f2d2d5;\n    border-radius: 20px;\n    padding: 8px 12px;\n}\n.anna-duration {\n    font-size: 12px;\n    color: var(--anna-muted);\n}\n.anna-stage {\n    position: relative;\n    min-width: 0;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n.anna-presence {\n    flex: 1;\n    min-height: 0;\n    overflow: auto;\n    padding: 32px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    background: radial-gradient(ellipse at 50% 40%, #e5eee3 0, #f3f4ed 48%, #f8f8f3 100%);\n}\n.anna-presence-kicker {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 12px;\n    color: var(--anna-muted);\n    margin-bottom: 32px;\n}\n.anna-portrait {\n    width: clamp(160px, 23vw, 330px);\n    aspect-ratio: 1;\n    border-radius: 50%;\n    padding: 9px;\n    border: 1px solid #d7e0d1;\n    box-shadow: 0 15px 70px #465e4314;\n    flex: none;\n}\n.anna-portrait img,\n.anna-portrait > span {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 50%;\n    background: #dbe7da;\n    display: grid;\n    place-items: center;\n    font-size: 70px;\n    color: #608272;\n}\n.anna-presence-live .anna-portrait {\n    border-color: #639984;\n    box-shadow:\n        0 0 0 10px #6b9b7715,\n        0 15px 70px #465e4314;\n}\n.anna-presence-copy {\n    text-align: center;\n    margin: 30px 0 26px;\n}\n.anna-presence-copy h2 {\n    font-size: 34px;\n    font-weight: 400;\n    letter-spacing: -1px;\n    margin: 10px 0;\n}\n.anna-presence-copy p {\n    font-size: 14px;\n    color: var(--anna-muted);\n    line-height: 1.5;\n}\n.anna-quick-views {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n.anna-quick-views button {\n    min-width: 110px;\n    display: flex;\n    gap: 24px;\n    justify-content: space-between;\n    background: #ffffff90;\n    border: 1px solid #dce4d8;\n    border-radius: 10px;\n    padding: 13px 16px;\n    color: var(--anna-ink);\n    font-size: 13px;\n}\n.anna-workspace {\n    flex: 1;\n    min-height: 0;\n    min-width: 0;\n    flex-direction: column;\n    background: white;\n}\n.anna-workspace-toolbar {\n    flex: none;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 8px;\n    padding: 12px 14px;\n    border-bottom: 1px solid #e1e7e2;\n    background: #fafbf9;\n}\n.anna-workspace-toolbar button {\n    border: 0;\n    background: transparent;\n    color: var(--anna-ink);\n    font-size: 12px;\n    padding: 8px;\n    border-radius: 6px;\n}\n.anna-workspace-toolbar button:hover,\n.anna-workspace-toolbar button[aria-pressed='true'] {\n    background: #e6eee4;\n}\n.anna-workspace-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    min-width: 0;\n    overflow: hidden;\n    isolation: isolate;\n}\n.anna-pending {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex: none;\n    padding: 12px 16px;\n    background: #edf4ef;\n    font-size: 13px;\n}\n.anna-pending span {\n    flex: 1;\n}\n.anna-pending button,\n.anna-error button {\n    border: 1px solid #c9dbce;\n    background: white;\n    border-radius: 6px;\n    padding: 6px 10px;\n    color: var(--anna-accent);\n}\n.anna-error {\n    color: #a3373c;\n    padding: 10px;\n    font-size: 13px;\n    line-height: 1.5;\n}\n.anna-empty {\n    flex: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 14px;\n    padding: 28px;\n}\n.anna-muted {\n    color: var(--anna-muted);\n    font-size: 13px;\n}\n.anna-text-button {\n    border: 0;\n    background: none;\n    color: var(--anna-accent);\n    padding: 8px;\n}\n.anna-latest {\n    align-self: center;\n    border: 1px solid #dce4d8;\n    border-radius: 20px;\n    padding: 7px 14px;\n    color: var(--anna-accent);\n    background: white;\n}\n.anna-mobile-dock {\n    display: none;\n}\n@media (max-width: 760px) {\n    .anna-header {\n        height: 54px;\n        padding: 0 16px;\n    }\n    .anna-header-note {\n        display: none;\n    }\n    .anna-brand {\n        font-size: 26px !important;\n    }\n    .anna-layout {\n        display: flex;\n        flex-direction: column-reverse;\n        position: relative;\n    }\n    .anna-stage {\n        flex: 0 0 30%;\n    }\n    .anna-conversation {\n        flex: 1;\n        border-right: 0;\n        border-top: 1px solid #e1e7e2;\n    }\n    .anna-conversation-heading {\n        display: none;\n    }\n    .anna-presence {\n        flex-direction: row;\n        gap: 20px;\n        padding: 14px 20px;\n        justify-content: center;\n    }\n    .anna-presence-kicker,\n    .anna-quick-views {\n        display: none;\n    }\n    .anna-portrait {\n        width: 110px;\n        padding: 4px;\n    }\n    .anna-presence-copy {\n        margin: 0;\n        text-align: left;\n    }\n    .anna-presence-copy h2 {\n        font-size: 23px;\n    }\n    .anna-presence-copy p {\n        font-size: 12px;\n        max-width: 180px;\n        margin-bottom: 0;\n    }\n    .anna-presence-copy .anna-eyebrow {\n        font-size: 9px;\n    }\n    .anna-messages {\n        padding: 14px 16px;\n    }\n    .anna-welcome {\n        padding: 18px 4px;\n    }\n    .anna-welcome h1 {\n        font-size: 28px;\n    }\n    .anna-welcome p {\n        font-size: 13px;\n        margin-bottom: 16px;\n    }\n    .anna-suggestions {\n        flex-direction: row;\n        flex-wrap: wrap;\n    }\n    .anna-suggestions button {\n        font-size: 12px;\n        padding: 9px 10px;\n    }\n    .anna-composer {\n        margin: 0 14px;\n    }\n    .anna-composer-footer span:last-child {\n        display: none;\n    }\n    .anna-voice-controls {\n        padding: 0 14px max(8px, env(safe-area-inset-bottom));\n    }\n    .anna-has-workspace .anna-stage {\n        flex: 1;\n    }\n    .anna-has-workspace .anna-conversation {\n        flex: 0 0 auto;\n    }\n    .anna-has-workspace .anna-conversation .anna-messages,\n    .anna-has-workspace .anna-context {\n        display: none;\n    }\n    .anna-has-workspace .anna-mobile-dock {\n        display: flex;\n        gap: 10px;\n        align-items: center;\n        padding: 10px 16px;\n        width: 100%;\n        background: white;\n        border: 0;\n        font-size: 13px;\n        color: var(--anna-ink);\n    }\n    .anna-mobile-dock img {\n        width: 28px;\n        height: 28px;\n        border-radius: 50%;\n        object-fit: cover;\n    }\n    .anna-mobile-dock span:last-child {\n        margin-left: auto;\n    }\n    .anna-chat-expanded.anna-has-workspace .anna-conversation {\n        position: absolute;\n        bottom: 0;\n        width: 100%;\n        height: 78%;\n        z-index: 30;\n        border-radius: 18px 18px 0 0;\n        box-shadow: 0 -12px 45px #18302630;\n        overflow: hidden;\n    }\n    .anna-chat-expanded.anna-has-workspace .anna-conversation .anna-messages {\n        display: block;\n    }\n    .anna-workspace-toolbar {\n        padding: 4px 8px;\n        gap: 0;\n    }\n    .anna-workspace-toolbar button {\n        font-size: 11px;\n        padding: 9px 6px;\n    }\n    .app-keyboard-open .anna-shell .anna-stage {\n        flex-basis: 0;\n    }\n    .app-keyboard-open .anna-shell.anna-has-workspace .anna-conversation {\n        height: 100%;\n    }\n}\n\n/* Temporary overlays: the actual task/note DOM and text selection remain untouched. */\n.anna-highlight-overlay {\n    position: fixed;\n    inset: 0;\n    pointer-events: none;\n    z-index: 10000;\n}\n.anna-highlight-overlay span {\n    position: absolute;\n    pointer-events: none;\n    border-radius: 3px;\n    box-sizing: border-box;\n}\n.anna-highlight-marker {\n    background: rgba(255, 211, 64, 0.38);\n    border-bottom: 2px solid #c79100;\n}\n.anna-highlight-outline {\n    outline: 2px solid #27806a;\n    outline-offset: 2px;\n    background: rgba(65, 166, 131, 0.08);\n}\n.anna-workspace-content {\n    position: relative;\n}\n.anna-highlight-caption {\n    position: absolute;\n    top: 8px;\n    right: 12px;\n    max-width: min(340px, calc(100% - 24px));\n    z-index: 31;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 9px 12px;\n    border: 1px solid #d9bf6d;\n    border-radius: 9px;\n    color: #493d18;\n    background: #fff8db;\n    box-shadow: 0 3px 14px #493d1818;\n    font-size: 12px;\n}\n.anna-highlight-caption span {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.anna-highlight-caption button {\n    border: 0;\n    background: transparent;\n    color: inherit;\n    padding: 4px;\n}\n\n.anna-mobile-tabs,\n.anna-conversation,\n.anna-header,\n.anna-workspace-toolbar,\n.anna-browser-surface,\n.anna-pending {\n    font-family: Roboto, Arial, sans-serif;\n    color: var(--anna-ink);\n}\n\n/* The workspace subtree stays in the same position in both layouts. */\n.anna-zoom-shell > [hidden],\n.anna-zoom-shell .anna-workspace-toolbar[hidden] {\n    display: none !important;\n}\n.anna-zoom-shell .anna-layout {\n    grid-template-columns: minmax(280px, var(--anna-chat-width, 36%)) 6px minmax(0, 1fr);\n}\n.anna-zoom-shell .anna-stage {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n.anna-zoom-shell .anna-workspace {\n    display: flex;\n    flex: 1;\n    min-height: 0;\n}\n.anna-zoom-shell .anna-workspace-content {\n    display: flex;\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n}\n.anna-zoom-shell .anna-workspace-content > * {\n    min-width: 0;\n}\n.anna-zoom-shell .anna-conversation {\n    min-width: 0;\n}\n.anna-zoom-back,\n.anna-control {\n    margin-left: auto;\n}\n.anna-zoom-shell .anna-brand {\n    font-size: 19px !important;\n    letter-spacing: 0;\n}\n.anna-divider {\n    cursor: col-resize;\n    touch-action: none;\n    background: #e1e7e2;\n}\n.anna-divider:hover,\n.anna-divider:focus-visible {\n    background: #89b2a4;\n}\n.anna-mobile-tabs {\n    display: none;\n}\n.anna-surface-hidden {\n    position: absolute !important;\n    inset: 0;\n    visibility: hidden;\n    pointer-events: none;\n}\n.anna-fullscreen {\n    background: transparent;\n}\n.anna-fullscreen .anna-layout {\n    display: flex;\n    flex: 1;\n}\n.anna-fullscreen .anna-conversation,\n.anna-fullscreen .anna-divider {\n    display: none;\n}\n.anna-fullscreen .anna-stage {\n    flex: 1;\n}\n.anna-fullscreen .anna-workspace {\n    width: 100%;\n}\n.anna-date-divider {\n    text-align: center;\n    color: var(--anna-muted);\n    margin: 16px 0;\n    font-size: 12px;\n}\n.anna-browser-surface {\n    flex: 1;\n    min-height: 0;\n    overflow: auto;\n    background: #f7f8f5;\n}\n.anna-browser-workspace {\n    padding: 16px;\n}\n.anna-browser-heading {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    justify-content: space-between;\n}\n.anna-browser-heading > div {\n    min-width: 0;\n    overflow-wrap: anywhere;\n}\n.anna-browser-heading button {\n    flex: none;\n}\n.anna-browser-workspace button {\n    border: 1px solid #d4ded8;\n    background: white;\n    border-radius: 7px;\n    padding: 8px 12px;\n}\n.anna-browser-frame {\n    margin: 12px 0;\n    background: #e1e7e2;\n}\n.anna-browser-frame img {\n    display: block;\n    width: 100%;\n    height: auto;\n}\n.anna-browser-controls form {\n    display: flex;\n    gap: 8px;\n    margin-bottom: 8px;\n}\n.anna-browser-controls input {\n    min-width: 0;\n    flex: 1;\n    padding: 8px;\n    border: 1px solid #d4ded8;\n    border-radius: 6px;\n    font-size: 16px;\n}\n.anna-browser-controls > div {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n}\n.anna-small {\n    font-size: 12px;\n    color: var(--anna-muted);\n    margin-top: 8px;\n}\n@media (max-width: 760px) {\n    .anna-zoom-shell .anna-layout {\n        display: flex;\n        flex-direction: column;\n        position: relative;\n    }\n    .anna-zoom-shell .anna-divider {\n        display: none;\n    }\n    .anna-zoom-shell .anna-mobile-tabs {\n        display: flex;\n        background: white;\n        padding: 6px 12px;\n        gap: 8px;\n    }\n    .anna-mobile-tabs button {\n        flex: 1;\n        border: 0;\n        border-radius: 8px;\n        padding: 10px;\n        background: #f0f3ef;\n    }\n    .anna-mobile-tabs button[aria-pressed='true'] {\n        color: white;\n        background: #276b5e;\n    }\n    .anna-zoom-shell .anna-stage,\n    .anna-zoom-shell .anna-conversation {\n        flex: 1;\n        min-height: 0;\n    }\n    .anna-zoom-active.anna-mobile-chat .anna-stage,\n    .anna-zoom-active.anna-mobile-workspace .anna-conversation {\n        position: absolute;\n        inset: 0;\n        visibility: hidden;\n        pointer-events: none;\n    }\n    .anna-fullscreen .anna-stage {\n        visibility: visible;\n        position: relative;\n    }\n    .anna-zoom-shell .anna-header {\n        height: auto;\n        min-height: 54px;\n        gap: 8px;\n    }\n    .anna-zoom-shell .anna-brand {\n        font-size: 16px !important;\n    }\n    .anna-zoom-shell .anna-zoom-back {\n        font-size: 12px;\n    }\n    .anna-browser-heading {\n        flex-wrap: wrap;\n    }\n}\n\n.anna-zoom-back {\n    border: 1px solid #d4ded8;\n    background: white;\n    border-radius: 8px;\n    padding: 9px 14px;\n    color: var(--anna-ink);\n}\n.anna-zoom-back:hover {\n    background: #edf4ef;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
